export default "__VITE_ASSET__Crb9Tv9V__"